"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationWatcher = void 0;
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var history_1 = require("history");
var getUrlQuery_1 = require("../../routes/getUrlQuery");
var getIsRoutes_1 = require("../../routes/getIsRoutes");
var analyticsEventBase_1 = require("../../sdks/firebase/analyticsEventBase");
var description = 'LocationWatcher';
var LocationWatcher = function (_a) {
    var history = _a.history, appRoutes = _a.appRoutes, queryNames = _a.queryNames;
    var dispatch = (0, react_redux_1.useDispatch)();
    (0, react_1.useEffect)(function () {
        var callback = function (_a) {
            var location = _a.location;
            var search = location.search, hash = location.hash, pathname = location.pathname;
            (0, analyticsEventBase_1.analyticsEventBase)({
                event: 'Page view',
                eventParams: {
                    pathname: pathname,
                },
            });
            var isRoutes = (0, getIsRoutes_1.getIsRoutes)({
                pathname: pathname,
                routes: appRoutes,
            });
            var urlQuery = (0, getUrlQuery_1.getUrlQuery)({
                search: search,
                queryNames: queryNames,
            });
            dispatch({
                type: 'LOCATION_CHANGE',
                description: description,
                values: {
                    query: urlQuery,
                    queryString: search,
                    hash: hash,
                    pathname: pathname,
                    isRoutes: isRoutes,
                },
            });
        };
        var unsubscribeFromHistory = history.listen(callback);
        callback({ location: history.location, action: history_1.Action.Push });
        return function () {
            unsubscribeFromHistory();
        };
    }, [dispatch, history, appRoutes, queryNames]);
    return null;
};
exports.LocationWatcher = LocationWatcher;
